import cookies from 'js-cookie';

import clearSite from './clearSite';

import { VERSION_CLEARED } from '~/constants';

export const resetCSR = () => {
  const versionCleared = cookies.get(VERSION_CLEARED);
  const nowVersion = import.meta.env.VITE_APP_VERSION;
  const clearVersions = (import.meta.env.VITE_CLEAR_VERSION ?? '').split(',');
  /**
   * 检测 versionCleared 标记，
   * 如果为空，或者已清理的版本与当前版本不一致，
   * 同时当前版本在 clearVersions 中，则清理站点数据
   * 清理完成后标记为已清理，后续刷新页面不再清理
   */
  if (
    (!versionCleared || versionCleared !== nowVersion) &&
    (clearVersions.includes(nowVersion) || clearVersions.includes(versionCleared))
  ) {
    clearSite();
    cookies.set(VERSION_CLEARED, nowVersion);
    console.log(
      `clear version:【${nowVersion}】`,
      `now cookies:【${document.cookie}】`,
      `storage:【${localStorage.length}】`
    );
  }
};
